import { render, staticRenderFns } from "./LanguageMessage.vue?vue&type=template&id=44a66dda&scoped=true"
import script from "./LanguageMessage.vue?vue&type=script&lang=js"
export * from "./LanguageMessage.vue?vue&type=script&lang=js"
import style0 from "./LanguageMessage.vue?vue&type=style&index=0&id=44a66dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a66dda",
  null
  
)

export default component.exports